import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Image, polymorphicFactory, useProps } from '@coveord/plasma-mantine';
import loadingSpinnerGif from '../../images/coveo-spinner.gif';
import noContentSvg from '../../images/no-content.svg';
import notAvailableSvg from '../../images/not-available.svg';
import notFoundSvg from '../../images/not-found.svg';
import unexpectedErrorSvg from '../../images/unexpected-error.svg';
import { useEmptyStateContext } from './EmptyStateContext.js';
var defaultProps = {
    illustration: 'not-found'
};
var emptyStateIllustrations = {
    'no-content': noContentSvg,
    'not-available': notAvailableSvg,
    'not-found': notFoundSvg,
    'coveo-spinner': loadingSpinnerGif,
    'unexpected-error': unexpectedErrorSvg
};
export var EmptyStateImage = polymorphicFactory(function(_props) {
    var ctx = useEmptyStateContext();
    var _useProps = useProps('EmptyStateImage', defaultProps, _props), style = _useProps.style, className = _useProps.className, classNames = _useProps.classNames, styles = _useProps.styles, _unstyled = _useProps.unstyled, illustration = _useProps.illustration, ref = _useProps.ref, others = _object_without_properties(_useProps, [
        "style",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "illustration",
        "ref"
    ]);
    return /*#__PURE__*/ _jsx(Image, _object_spread({
        ref: ref,
        src: illustration ? emptyStateIllustrations[illustration] : undefined,
        fit: "cover"
    }, ctx.getStyles('image', {
        classNames: classNames,
        className: className,
        styles: styles,
        style: style
    }), others));
});
EmptyStateImage.displayName = 'EmptyState.Image';

//# sourceMappingURL=EmptyStateImage.js.map